<template>
  <div
    class="container icon-upload"
    ref="container"
  >
    <el-upload
      :action="uploadSrc"
      name="img"
      :headers="{ 'X-Requested-With': 'XMLHttpRequest' }"
      class="icon-upload"
      :class="{ disabled: icons.length >= listLength }"
      :disabled="icons.length >= listLength"
      :title="uploadTitle"
      :data="uploadData"
      :on-success="uploadSuccess"
      :on-error="uploadFail"
      :show-file-list="false"
      :before-upload="beforeUpload"
    >
      <div class="icon">
        <i class="h-icon-add"></i>
      </div>
    </el-upload>
    <div
      v-for="icon in icons"
      class="icon-show"
      :key="icon.fileId"
      :class="{
        active: icon.fileId === activeId,
        selected: icon.fileId === selected,
        'icon-upload-border-color':icon.fileId === selected
      }"
      @click="changeActive(icon)"
    >
      <image-loader
        :src="icon.path"
        no-bg
        class="icon-inner"
      ></image-loader>
      <div class="operator-wrapper">
        <i
          class="btn h-icon-delete"
          @click="removeImage(icon)"
        ></i>
      </div>
    </div>
  </div>
</template>

<script>
import configuration from 'api/config'
import API from 'api/api'
import { ErrorHandleMixin, LoadingMixin } from 'utils/mixin'
import ImageLoader from 'components/image-loader/image-loader'
export default {
  name: 'icon-upload',
  model: {
    prop: 'activeId'
  },
  props: {
    type: String,
    activeId: [String, Number],
    selected: [String, Number],
    listLength: {
      type: Number,
      default: 4
    }
  },
  data () {
    return {
      icons: [],
      loadingInstance: null
    }
  },
  computed: {
    uploadSrc () {
      return `${configuration.baseUrl}${configuration.uploadSrc}`
    },
    uploadData () {
      return {
        usageScenario: this.type
      }
    },
    uploadTitle () {
      if (this.icons.length >= this.listLength) {
        // 可选图标长度
        if (this.listLength === 4) {
          return this.$t('common.upload_logo_max_text')
        } else {
          return this.$t('common.upload_logo_max_text2')
        }
      } else {
        return this.$t('common.upload_logo_text')
      }
    }
  },
  methods: {
    _getList () {
      API.common
        .getAttachmentList({
          type: this.type
        })
        .then(res => {
          this.icons = res.data.list || []
        })
        .catch(this._handleError)
    },
    beforeUpload (file) {
      if (!/.(png|jpg|JPG|PNG)$/.test(file.name)) {
        this.$message.error(this.$t('common.image_type_error'))
        return false
      }
      this.loadingInstance = this._getLoading()
      API.common.keepAlive()
      return true
    },
    uploadSuccess (response, file) {
      this.loadingInstance && this.loadingInstance.close()
      if (response.code === '0') {
        this.$message.success(this.$t('common.upload_success'))
        this.icons.push({
          fileId: response.data.fileId,
          path: response.data.path,
          width: response.data.width,
          height: response.data.height
        })
      } else {
        this.$message.error(response.msg)
      }
    },
    uploadFail () {
      this.loadingInstance.close()
    },
    removeImage (icon) {
      if (icon.fileId === this.selected) {
        this.$message.warning(this.$t('common.logo_rule_tip'))
      } else {
        this.$confirm(this.$t('common.logo_delete_confirm'), {
          confirmButtonText: this.$t('common.confirmBtn_text'),
          cancelButtonText: this.$t('common.cancelBtn_text'),
          type: 'question'
        })
          .then(() => {
            API.common
              .deleteAttachment({
                fileId: icon.fileId
              })
              .then(res => {
                this.$message.success(this.$t('common.logo_delete_success'))
                this.icons = this.icons.filter(item => {
                  return item.fileId !== icon.fileId
                })
                this.resetIcon(icon)
              })
              .catch(this._handleError)
          })
          .catch(() => { })
      }
    },
    changeActive (icon) {
      this.$emit('input', icon.fileId)
      this.$emit('change', icon)
    },
    resetIcon (icon) {
      if (this.activeId === icon.fileId) {
        if (this.icons.length > 0) {
          this.changeActive(this.icons[0])
        } else {
          this.changeActive({
            fileId: -1,
            path: ''
          })
        }
      }
    }
  },
  mounted () {
    this._getList()
  },
  mixins: [ErrorHandleMixin, LoadingMixin],
  components: {
    ImageLoader
  }
}
</script>

<style scoped lang="less" rel="stylesheet/less">
.icon-upload.container {
  width: 100%;
  height: 64px;
  font-size: 0;
  /deep/ .el-loading-mask {
    .el-loading-spinner {
      margin-top: -55px;
    }
  }
  .icon-show {
    display: inline-block;
    width: 64px;
    height: 64px;
    margin-left: 8px;
    vertical-align: top;
    cursor: pointer;
    position: relative;
    border: 1px solid rgba(0, 0, 0, 0.08);
    border-radius: 2px;
    .operator-wrapper {
      position: absolute;
      left: 0;
      top: 0;
      width: 100%;
      height: 100%;
      background-color: rgba(0, 0, 0, 0.7);
      display: none;
      .btn {
        width: 24px;
        height: 24px;
        display: block;
        cursor: pointer;
        position: absolute;
        left: 50%;
        top: 50%;
        margin-left: -12px;
        margin-top: -12px;
        font-size: 24px;
        color: #fff;
      }
    }
    &.active {
      width: 64px;
      height: 64px;
      border-width: 2px;
      border-style: solid;
    }
    &:hover {
      border-width: 1px;
      border-style: solid;
      .operator-wrapper {
        display: block;
      }
    }
    &.selected:after {
      content: "";
      display: block;
      width: 8px;
      height: 8px;
      position: absolute;
      top: 1px;
      right: 1px;
      background: url("../../assets/images/common_icon_apply.png") center
        no-repeat;
    }
    &.selected:before {
      content: "";
      display: block;
      width: 0px;
      height: 0px;
      position: absolute;
      top: 0px;
      right: 0px;
      border-left: 16px solid transparent;
    }
    .icon-inner {
      box-sizing: border-box;
      border: 1px solid #fff;
    }
  }
  .icon-upload {
    display: inline-block;
    width: 64px;
    height: 64px;
    background: rgba(0, 0, 0, 0.04);
    .icon {
      width: 64px;
      height: 64px;
      line-height: 64px;
      box-sizing: border-box;
      border: 1px dashed rgba(0, 0, 0, 0.12);
      color: rgba(0, 0, 0, 0.4);
      i {
        display: block;
        float: left;
        margin: 19px;
        width: 24px;
        height: 24px;
        font-size: 24px;
      }
    }
    &:hover {
      background: rgba(0, 0, 0, 0.08);
    }
    &:active {
      background: rgba(0, 0, 0, 0.12);
    }
  }
  .icon-upload.disabled {
    .icon {
      cursor: not-allowed;
    }
  }
}
</style>
